<!-- Published box of the video dialog (#publishedBox, under the status pills; empty and hidden for a new video): a
     published video says it is in "Published videos" with "Back to the plan", the others have "Mark as published". Both
     save the video at once with the new state and close the dialog (video store setVideoPublished). -->
<script setup lang="ts">
import { useI18n } from '../../composables/useI18n'
import { useVideoStore } from '../../stores/video'

const { t } = useI18n()
const video = useVideoStore()
</script>

<template>
  <div id="publishedBox" class="mt-3 empty:hidden"><template v-if="video.form?.id">
    <div v-if="video.published" class="flex items-center gap-3 p-3 rounded-xl border border-green-400/30 bg-green-400/10">
      <i class="fas fa-flag-checkered text-green-400"></i><span class="flex-1 text-xs text-gray-200" v-html="t('This video is in <b>Published videos</b>: it does not appear on the Board.')"></span>
      <button type="button" class="text-xs font-bold text-brand hover:underline whitespace-nowrap" @click="video.setVideoPublished(false)"><i class="fas fa-rotate-left mr-1"></i>{{ t('Back to the plan') }}</button></div>
    <template v-else>
      <button type="button" class="w-full flex items-center justify-center gap-2 py-2.5 rounded-xl border border-gray-800 bg-darkinput text-sm font-bold text-gray-200 hover:border-brand/60 hover:text-brand transition" @click="video.setVideoPublished(true)"><i class="fas fa-flag-checkered"></i>{{ t('Mark as published') }}</button>
      <p class="text-[11px] text-gray-500 mt-1.5">{{ t('The video leaves the Board and goes to the "Published videos" page. You can put it back in the plan whenever you like.') }}</p>
    </template>
  </template></div>
</template>
